import { render, staticRenderFns } from "./ActivitySetting.vue?vue&type=template&id=45caf787&scoped=true&"
import script from "./ActivitySetting.vue?vue&type=script&lang=js&"
export * from "./ActivitySetting.vue?vue&type=script&lang=js&"
import style0 from "./ActivitySetting.vue?vue&type=style&index=0&id=45caf787&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45caf787",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45caf787')) {
      api.createRecord('45caf787', component.options)
    } else {
      api.reload('45caf787', component.options)
    }
    module.hot.accept("./ActivitySetting.vue?vue&type=template&id=45caf787&scoped=true&", function () {
      api.rerender('45caf787', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ActivityManage/modules/ActivitySetting.vue"
export default component.exports